export type Film = {
  id: string;
  title: string;
  enTitle: string;
  year: number;
  director: string;
  cast: string[];
  duration: number;
  region: string;
  genres: string[];
  categories: string[];
  heat: number;
  tagline: string;
  synopsis: string[];
  poster: string;
  backdrop?: string;
  featured?: boolean;
};

export type Category = {
  key: string;
  name: string;
  icon: string;
  desc: string;
};

export const films: Film[] = [
  {
    id: "midnight-harbour",
    title: "夜航码头",
    enTitle: "Midnight Harbour",
    year: 1993,
    director: "陈墨白",
    cast: ["林嘉禾", "苏晓桐", "何柏舟"],
    duration: 98,
    region: "香港",
    genres: ["剧情", "爱情"],
    categories: ["classic", "retro", "romance", "auteur"],
    heat: 98,
    tagline: "有些告别，只在潮水退去之后才说得出口。",
    synopsis: [
      "深夜的维多利亚港漂着薄雾，码头管理员阿澄每晚都在同一时间记录进出的船次。她与一名常年往返港澳的船员维持着一种没有名分的关系：不问去向，不留地址，只在潮水涨落之间短暂相聚。",
      "一封被海水浸透的信打破了这份默契。信里写着一个她从未听过的地址，也写着一个早已存在的家庭。阿澄第一次决定在工作之外追问答案，而这趟追问把她带回了自己一直试图离开的旧城区。",
      "影片以大量雨夜长镜头铺陈情绪，把码头、渡轮与霓虹招牌拍成一座漂浮的城。结尾处她仍站在同一级台阶上，只是手上那把伞换了颜色。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20illustration%20of%20a%20lone%20woman%20in%20a%20dark%20trench%20coat%20standing%20on%20a%20rain-soaked%20harbour%20pier%20at%20night%2C%20distant%20ship%20lights%20reflecting%20on%20black%20water%2C%20deep%20navy%20and%20amber%20palette%2C%20dramatic%20rim%20light%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=film-night-harbour-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain-soaked%20harbour%20at%20night%20with%20distant%20ship%20lights%20and%20mist%2C%20deep%20navy%20water%2C%20warm%20amber%20lamps%20along%20the%20pier%2C%20atmospheric%20painterly%20illustration%2C%20no%20text&width=1600&height=900&seq=bd-night-harbour-01&orientation=landscape",
    featured: true,
  },
  {
    id: "red-umbrella-alley",
    title: "红伞巷",
    enTitle: "The Red Umbrella",
    year: 1995,
    director: "关静山",
    cast: ["温婉仪", "赵允行", "杜若"],
    duration: 104,
    region: "香港",
    genres: ["悬疑", "剧情"],
    categories: ["classic", "retro", "suspense"],
    heat: 95,
    tagline: "巷子只有七米宽，却困住了一个人十年。",
    synopsis: [
      "旧区拆迁在即，窄巷里的住户陆续搬走，只剩下开裁缝铺的碧姨。她每天撑一把红伞出门买菜，风雨不改，好像那把伞是某种仪式。",
      "年轻的测量员阿哲被派来做最后的地籍核对，却发现图纸上根本没有碧姨的铺面。他开始暗中调查，逐渐拼出一个被邻里默契掩盖多年的夜晚——以及一把从未归还的伞。",
      "影片几乎全部在巷内实景拍摄，红伞成为唯一的亮色。结尾的拆迁镜头长达两分钟，没有人说话。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20woman%20holding%20a%20red%20umbrella%20in%20a%20narrow%20old%20alley%2C%20wet%20cobblestones%20mirroring%20neon%20signage%2C%20teal%20and%20crimson%20palette%2C%20heavy%20atmospheric%20rain%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=film-red-umbrella-02&orientation=portrait",
  },
  {
    id: "fragrant-hotel",
    title: "芳华旅社",
    enTitle: "The Fragrant Hotel",
    year: 1997,
    director: "苏念真",
    cast: ["李曼青", "周庭深", "罗嘉禾"],
    duration: 92,
    region: "台湾",
    genres: ["剧情", "爱情"],
    categories: ["classic", "retro", "romance"],
    heat: 91,
    tagline: "旅社的十二间客房，住过十二种不肯回家的人。",
    synopsis: [
      "城郊的芳华旅社只有十二间房，柜台后永远摆着一瓶快凋谢的白花。老板娘月姐记得每位长住客的名字，也记得他们从不肯提起的事。",
      "一个雨夜，一位自称来出差的男人住进了尽头那间房。他的作息和十年前离开的一位客人一模一样，让月姐不得不重新整理自己刻意封存的记忆。",
      "影片用一间旅社串起数个短章，灯光的暖与走廊的冷形成鲜明对照。最后镜头停在换了新床单的空房上，窗帘轻轻动着。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20vintage%20hotel%20corridor%20with%20warm%20tungsten%20lamps%2C%20an%20open%20door%20casting%20amber%20light%2C%20faded%20teal%20wallpaper%2C%20deep%20shadows%2C%20nostalgic%20film%20still%20mood%2C%20no%20text&width=600&height=900&seq=film-fragrant-hotel-03&orientation=portrait",
  },
  {
    id: "velvet-tram",
    title: "丝绒电车",
    enTitle: "Velvet Tram",
    year: 1996,
    director: "陈墨白",
    cast: ["沈靜", "许长安", "白露"],
    duration: 88,
    region: "香港",
    genres: ["剧情", "文艺"],
    categories: ["classic", "retro", "auteur"],
    heat: 88,
    tagline: "末班车上，没有人报站名。",
    synopsis: [
      "一辆即将退役的老电车，每晚十一点半从东端总站出发，绕城一圈再回来。司机老麦开了二十六年，他认得每一个在这个时间上车的乘客。",
      "一位总在第七站上车的女人从不说话，只坐在最后一排靠窗的位置。某天她带来一只旧皮箱，老麦终于决定在她下车前说点什么。",
      "全片几乎没有外景，车窗外的城市像一卷缓慢播放的胶片。对白极少，靠轨道声和光线完成叙事。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20an%20empty%20midnight%20tram%20interior%20with%20velvet%20seats%2C%20a%20woman%20silhouette%20by%20the%20window%2C%20cold%20blue%20light%20and%20warm%20lamp%20accents%2C%20grainy%201990s%20film%20texture%2C%20painterly%2C%20no%20text&width=600&height=900&seq=film-velvet-tram-04&orientation=portrait",
  },
  {
    id: "glass-lover",
    title: "玻璃情人",
    enTitle: "Glass Lover",
    year: 1991,
    director: "何雨川",
    cast: ["区婉玲", "程之远"],
    duration: 96,
    region: "香港",
    genres: ["爱情", "剧情"],
    categories: ["classic", "retro", "romance"],
    heat: 86,
    tagline: "隔着一层玻璃，我们都学会了说真话。",
    synopsis: [
      "玻璃厂的质检员阿雯每天要检查上千片玻璃，她能在反光里看见整条街的日常。对面写字楼里有个男人，每晚七点准时关灯，隔着两层玻璃与她对望。",
      "两人从未正式认识，却通过贴在窗上的字条交流了整整一个夏天。当男人终于走到玻璃厂门口时，阿雯却选择先关掉了车间所有的灯。",
      "影片以玻璃的折射和破碎作为核心意象，取景克制，光线干净，是港产文艺片中少见的内敛之作。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20woman%20behind%20a%20rain-streaked%20glass%20window%2C%20blurred%20city%20lights%2C%20cool%20blue%20tones%20with%20one%20amber%20highlight%2C%20reflective%20glass%20fragments%2C%20painterly%20poster%20art%2C%20no%20text&width=600&height=900&seq=film-glass-lover-05&orientation=portrait",
  },
  {
    id: "smoke-and-honey",
    title: "烟与蜜",
    enTitle: "Smoke and Honey",
    year: 1998,
    director: "关静山",
    cast: ["邵眉", "唐砚", "林知秋"],
    duration: 101,
    region: "香港",
    genres: ["悬疑", "剧情"],
    categories: ["classic", "retro", "suspense"],
    heat: 84,
    tagline: "酒吧的账本上，记着客人不愿意承认的名字。",
    synopsis: [
      "湾仔一间没有招牌的地下酒吧，调酒师阿棠只做两种酒：一杯叫烟，一杯叫蜜。熟客都知道，点哪一杯等于承认自己今晚是什么状态。",
      "一个女人的出现让酒吧接连发生怪事：老客人不再来，账本上多出几笔不存在的消费，而阿棠的合伙人突然失踪。",
      "影片在极小的空间内完成大部分调度，烟雾和琥珀色灯光几乎成为第三位主角。真相揭晓时，镜头始终没有离开吧台。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20smoky%20dim%20bar%20counter%2C%20a%20glass%20of%20amber%20whiskey%2C%20curling%20cigarette%20smoke%2C%20dark%20navy%20shadows%2C%20warm%20amber%20spotlight%2C%20film%20noir%20illustration%2C%20no%20text&width=600&height=900&seq=film-smoke-honey-06&orientation=portrait",
  },
  {
    id: "night-ferry",
    title: "夜渡",
    enTitle: "Night Crossing",
    year: 1992,
    director: "苏念真",
    cast: ["郑海宁", "叶葳", "吴柏言"],
    duration: 94,
    region: "香港",
    genres: ["剧情", "文艺"],
    categories: ["classic", "retro", "auteur"],
    heat: 82,
    tagline: "船开出去四十分钟，够说一件藏了十年的事。",
    synopsis: [
      "一班凌晨开出的小渡轮，每晚只有三四个乘客。船员阿海负责收票，也负责在雾大时敲钟提醒。他的生活像这条航线一样固定。",
      "某夜，一位多年未见的旧友带着一个陌生女孩上船。四十分钟的航程里，三个人各自说了半句真话，剩下的被雾吃掉了。",
      "影片只有一个主要场景，却通过潮声、汽笛与远处灯火的明灭完成时间流逝。它被影评人形容为「一场安静的审问」。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20small%20ferry%20crossing%20dark%20water%20at%20night%2C%20mist%2C%20glowing%20lantern%20on%20deck%2C%20silhouette%20of%20two%20passengers%20apart%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20painterly%2C%20no%20text&width=600&height=900&seq=film-night-ferry-07&orientation=portrait",
  },
  {
    id: "cigarette-before-dawn",
    title: "黎明前一支烟",
    enTitle: "One Cigarette Before Dawn",
    year: 1999,
    director: "何雨川",
    cast: ["简宁", "高以安", "苏眉"],
    duration: 90,
    region: "香港",
    genres: ["爱情", "剧情"],
    categories: ["classic", "retro", "romance"],
    heat: 80,
    tagline: "天亮之后，我们都要回到各自的生活里。",
    synopsis: [
      "千禧年前夕，一个天台上聚着三个不想回家的人。他们彼此并不熟，却因为一场停电被留在同一片夜色里。",
      "在等待日出的两个小时里，三个人交换了各自最不愿被记住的时刻。当第一班车从楼下的高架驶过，他们商量好从此不再提起这一晚。",
      "影片用一段不停歇的长镜头完成整场对话，城市的光从头到尾在变，人却越来越安静。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20rooftop%20at%20blue%20hour%20before%20sunrise%2C%20a%20woman%20smoking%20by%20the%20railing%2C%20city%20skyline%20glow%2C%20cool%20blue%20and%20orange%20gradient%20sky%2C%20painterly%20film%20poster%2C%20no%20text&width=600&height=900&seq=film-dawn-cigarette-08&orientation=portrait",
  },
  {
    id: "summer-of-lantern",
    title: "灯笼照夏",
    enTitle: "Summer of Lanterns",
    year: 1994,
    director: "罗维安",
    cast: ["何晓岚", "谢承熙"],
    duration: 97,
    region: "台湾",
    genres: ["爱情", "剧情"],
    categories: ["classic", "retro", "romance"],
    heat: 78,
    tagline: "灯笼亮起的时候，院子里的秘密就藏不住了。",
    synopsis: [
      "南部的老宅院每年夏天挂起红灯笼，为的是迎接许久未归的家族成员。这一年回来的，是一个所有人都以为不会回来的人。",
      "在闷热的十几个夜晚里，旧账被一件件翻出来，而最沉默的那位反而成了所有人情绪的出口。灯笼的光很暖，照见的却大多是难堪。",
      "影片把台湾夏夜的湿度拍得几乎能闻到。结尾灯笼被一盏盏取下，院子第一次显得那么大。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20red%20paper%20lanterns%20glowing%20above%20a%20summer%20courtyard%2C%20silhouetted%20figure%20under%20the%20lantern%20light%2C%20warm%20amber%20and%20deep%20teal%20shadows%2C%20painterly%2C%20no%20text&width=600&height=900&seq=film-lantern-summer-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20red%20paper%20lanterns%20glowing%20above%20a%20summer%20courtyard%20at%20night%2C%20warm%20amber%20light%2C%20deep%20teal%20shadows%2C%20gentle%20rain%2C%20painterly%20illustration%2C%20no%20text&width=1600&height=900&seq=bd-lantern-summer-09&orientation=landscape",
    featured: true,
  },
  {
    id: "neon-confession",
    title: "霓虹告白",
    enTitle: "Neon Confession",
    year: 2024,
    director: "罗维安",
    cast: ["苏念", "陈屿", "梁星野"],
    duration: 109,
    region: "香港",
    genres: ["爱情", "都市"],
    categories: ["latest", "romance"],
    heat: 96,
    tagline: "这座城市从不缺告白，缺的是听完的人。",
    synopsis: [
      "外卖骑手阿屿每天穿过同一条霓虹街，把餐送到同一栋旧楼。他从未见过点单的人，只知道对方每晚都要求多加一份糖。",
      "一场暴雨让整条街停电，他第一次走上那层楼，发现门后是一个正准备搬走的女孩，以及满墙贴着的外卖单据。",
      "影片以手机竖屏画面与电影镜头交错剪辑，把城市的喧嚣与两个人的沉默放在同一画面里。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20cinematic%20poster%20art%20of%20a%20rain-soaked%20neon%20street%20with%20magenta%20and%20amber%20reflections%2C%20a%20couple%20under%20a%20translucent%20umbrella%20seen%20from%20behind%2C%20moody%20night%20photography%20style%2C%20no%20text&width=600&height=900&seq=film-neon-confession-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20neon-lit%20Asian%20street%20after%20rain%2C%20magenta%20and%20amber%20reflections%20on%20wet%20asphalt%2C%20blurred%20passers-by%20with%20umbrellas%2C%20moody%20night%20atmosphere%2C%20no%20text&width=1600&height=900&seq=bd-neon-confession-10&orientation=landscape",
    featured: true,
  },
  {
    id: "paper-moon-club",
    title: "纸月俱乐部",
    enTitle: "Paper Moon Club",
    year: 2023,
    director: "关静山",
    cast: ["白歆", "傅司南", "莫岚"],
    duration: 113,
    region: "香港",
    genres: ["悬疑", "剧情"],
    categories: ["latest", "suspense", "auteur"],
    heat: 93,
    tagline: "台上的人换了三次，观众一次都没走。",
    synopsis: [
      "纸月俱乐部是城中最后一家还在演出老派歌舞的场子。每晚十点，幕布拉开，一位女歌手唱同一首歌，二十年来没有变过。",
      "一名记者受邀来写俱乐部的告别报道，却在后台发现三本不同年代的演出名册，上面的名字几乎完全一样。",
      "影片以舞台前后两个空间互相映照，把「表演」这个词拆得很彻底。最后一首歌出现时，观众会知道谁一直在看。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20an%20art%20deco%20club%20stage%20with%20a%20single%20spotlight%2C%20red%20velvet%20curtains%2C%20a%20silhouetted%20performer%2C%20deep%20navy%20and%20gold%20palette%2C%20elegant%20mysterious%20mood%2C%20no%20text&width=600&height=900&seq=film-paper-moon-club-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20art%20deco%20theatre%20stage%20with%20red%20velvet%20curtains%20and%20a%20single%20golden%20spotlight%20cutting%20through%20haze%2C%20empty%20seats%20in%20shadow%2C%20elegant%20moody%20illustration%2C%20no%20text&width=1600&height=900&seq=bd-paper-moon-club-11&orientation=landscape",
    featured: true,
  },
  {
    id: "slow-tide",
    title: "潮汐缓慢",
    enTitle: "Slow Tide",
    year: 2022,
    director: "苏念真",
    cast: ["叶知秋", "林越", "方晴"],
    duration: 106,
    region: "台湾",
    genres: ["文艺", "剧情"],
    categories: ["latest", "auteur", "romance"],
    heat: 75,
    tagline: "海不会催人，但人总在赶时间。",
    synopsis: [
      "东部海岸的小村只剩七户人家。开民宿的晴姐接待了一位来写生的画家，对方一住就是三个月，却从没画完一幅作品。",
      "潮水每天退去两次，露出同一条礁石路。两个人在那条路上走了很多次，话越说越少，直到某天早上画家没有下楼吃早餐。",
      "影片几乎没有配乐，全部由海浪与风声构成。它更像一篇散文，讲的是人如何学着不追问。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20quiet%20seaside%20villa%20at%20dusk%2C%20long%20shadows%20on%20wet%20sand%2C%20curtains%20moving%20in%20the%20wind%2C%20muted%20teal%20and%20sand%20tones%2C%20melancholic%20painterly%20film%20poster%2C%20no%20text&width=600&height=900&seq=film-slow-tide-12&orientation=portrait",
  },
  {
    id: "rain-of-september",
    title: "九月有一场雨",
    enTitle: "Rain in September",
    year: 2025,
    director: "何雨川",
    cast: ["沈嘉言", "周牧", "温以宁"],
    duration: 111,
    region: "台湾",
    genres: ["爱情", "剧情"],
    categories: ["latest", "romance"],
    heat: 94,
    tagline: "那年九月，全城都在等一场没下的雨。",
    synopsis: [
      "气象主播嘉言每天在镜头前报告降雨概率，私下却因为一次误报被调离主播台。她回到老家，在公交站遇见了十年前的同班同学。",
      "两人开始每天在同一站牌下等车，聊的都是无关紧要的事。真正的答案藏在一段被剪掉的旧录像里，而那段录像正躺在嘉言的抽屉深处。",
      "影片把「预报」当作隐喻，谈的是人对关系的预判如何毁掉关系本身。结尾那场雨来得很轻，只够打湿一个人的肩膀。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20woman%20in%20a%20beige%20trench%20coat%20waiting%20under%20a%20bus%20stop%20shelter%20in%20heavy%20rain%2C%20blurred%20headlights%2C%20grey%20blue%20palette%20with%20amber%20accents%2C%20painterly%2C%20no%20text&width=600&height=900&seq=film-rain-september-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rainy%20city%20bus%20stop%20at%20dusk%20with%20blurred%20headlights%20and%20reflections%2C%20grey%20blue%20palette%20with%20warm%20amber%20accents%2C%20atmospheric%20painterly%20illustration%2C%20no%20text&width=1600&height=900&seq=bd-rain-september-13&orientation=landscape",
    featured: true,
  },
  {
    id: "borrowed-light",
    title: "借来的光",
    enTitle: "Borrowed Light",
    year: 2024,
    director: "陈墨白",
    cast: ["唐宁", "郭斯远", "许南"],
    duration: 105,
    region: "香港",
    genres: ["悬疑", "剧情"],
    categories: ["latest", "suspense", "auteur"],
    heat: 89,
    tagline: "放映机一停，房间就什么都不剩。",
    synopsis: [
      "一间私人放映室藏在旧工厂顶楼，老板只接待熟客，只放没有片名的老电影。有人说那些片子从未公映过。",
      "一位修复师受托来整理胶片，却发现其中一卷拍的是这间放映室本身，而且拍摄时间在十年之后。",
      "影片把光与影的关系推到极致，大量场景只有一束投影在墙上。结局没有解释，但最后一个镜头会让人重新理解开头。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20dark%20apartment%20with%20a%20projector%20beam%20cutting%20through%20haze%2C%20dust%20particles%20glowing%2C%20two%20silhouettes%20at%20the%20edges%20of%20the%20light%2C%20deep%20navy%20and%20warm%20amber%2C%20no%20text&width=600&height=900&seq=film-borrowed-light-14&orientation=portrait",
  },
  {
    id: "tenth-floor-window",
    title: "十楼的窗",
    enTitle: "The Tenth Floor Window",
    year: 2020,
    director: "罗维安",
    cast: ["简洁", "黎向晚", "陈默"],
    duration: 99,
    region: "香港",
    genres: ["文艺", "悬疑"],
    categories: ["latest", "auteur", "suspense"],
    heat: 72,
    tagline: "整栋楼只有一扇窗，每晚都亮到很晚。",
    synopsis: [
      "搬进旧楼第七层的女孩发现，对面十楼总有一扇窗亮着，无论多晚。她开始记录那扇窗的作息，像在写一份不属于自己的日记。",
      "记录到第三十天，窗里的人影做了一个只有她才会做的动作。她决定上楼，而那层楼在电梯按钮上并不存在。",
      "影片用极简的构图与重复的镜头制造压力，几乎不依赖音效。它讲的其实是独居者如何与自己对话。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20tall%20apartment%20building%20at%20night%2C%20one%20lit%20window%20among%20dark%20ones%2C%20a%20woman%20silhouette%20framed%20inside%2C%20cool%20blue%20facades%20and%20warm%20amber%20window%2C%20painterly%2C%20no%20text&width=600&height=900&seq=film-tenth-floor-15&orientation=portrait",
  },
  {
    id: "silent-proposal",
    title: "无声求婚",
    enTitle: "Silent Proposal",
    year: 2023,
    director: "关静山",
    cast: ["余温", "林泊", "赵小满"],
    duration: 102,
    region: "台湾",
    genres: ["爱情", "剧情"],
    categories: ["latest", "romance"],
    heat: 83,
    tagline: "他排练了一百次，最后什么都没说。",
    synopsis: [
      "餐厅主厨阿泊准备在周年夜向交往七年的女友求婚。他订下整间店，写好了每一道菜的寓意，甚至连背景音乐的顺序都排好了。",
      "当晚，女友带来了一个消息，让整份菜单瞬间失去意义。两个人坐在空荡的餐厅里，把一顿饭吃到了凌晨。",
      "影片全部发生在餐厅内，只有两个人与一桌没吃完的菜。它温柔地提醒观众：仪式感救不了关系，但诚实或许可以。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20candlelit%20dining%20table%20for%20two%20in%20an%20empty%20restaurant%2C%20wine%20glasses%2C%20scattered%20petals%2C%20warm%20amber%20light%20against%20deep%20navy%20shadows%2C%20painterly%20film%20poster%2C%20no%20text&width=600&height=900&seq=film-silent-proposal-16&orientation=portrait",
  },
  {
    id: "blue-hour-letter",
    title: "蓝调时刻的信",
    enTitle: "Letters at Blue Hour",
    year: 2021,
    director: "苏念真",
    cast: ["温亦柔", "程亦然", "白敬言"],
    duration: 95,
    region: "香港",
    genres: ["文艺", "爱情"],
    categories: ["latest", "auteur", "romance"],
    heat: 70,
    tagline: "有些信写完就该寄出，有些只适合留在抽屉里。",
    synopsis: [
      "整理母亲遗物时，女儿发现了三十七封从未寄出的信。收信人是一位她从未听过的人，地址是同一栋楼的另一层。",
      "她按地址找过去，开门的是一位独居的老先生。两人没有立刻相认，只是隔着门聊了几句天气。信最终没有被交出去。",
      "影片以蓝调时刻（日落后的二十分钟）为唯一色调，光线短暂而柔软。它谈的是错过这件事本身的重量。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20illustration%20of%20a%20woman%20reading%20a%20handwritten%20letter%20by%20a%20window%20at%20blue%20hour%2C%20sheer%20curtains%2C%20cool%20indigo%20shadows%20and%20a%20warm%20desk%20lamp%2C%20painterly%20nostalgic%20mood%2C%20no%20text&width=600&height=900&seq=film-blue-hour-letter-17&orientation=portrait",
  },
  {
    id: "rose-parlour",
    title: "玫瑰客厅",
    enTitle: "The Rose Parlour",
    year: 2025,
    director: "何雨川",
    cast: ["孟绯", "顾长安", "许愿"],
    duration: 108,
    region: "香港",
    genres: ["悬疑", "剧情"],
    categories: ["latest", "suspense"],
    heat: 92,
    tagline: "客厅里的玫瑰每一天都是新的，没人知道是谁换的。",
    synopsis: [
      "一栋半山老宅的客厅常年摆着一大束红玫瑰。屋主是一位很少露面的收藏家，管家每周替他接待一位不同的访客。",
      "年轻的保险调查员被派来评估藏品，却发现每位访客离开后都会留下一件不属于自己的东西。而那束玫瑰，永远保持着刚剪下的状态。",
      "影片在同一个客厅里完成全部叙事，靠陈设的细微变化推进时间。最后一束玫瑰被摆上时，观众才明白谁才是真正的主人。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20lavish%20velvet%20parlour%20with%20deep%20red%20roses%2C%20a%20mirrored%20wall%2C%20a%20woman%20silhouette%20in%20an%20armchair%2C%20dark%20navy%20and%20crimson%20palette%2C%20elegant%20suspenseful%20mood%2C%20no%20text&width=600&height=900&seq=film-rose-parlour-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dark%20velvet%20parlour%20with%20red%20roses%20and%20a%20mirrored%20wall%20reflecting%20warm%20candlelight%2C%20deep%20navy%20shadows%2C%20elegant%20suspenseful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=bd-rose-parlour-18&orientation=landscape",
    featured: true,
  },
];

export const categories: Category[] = [
  {
    key: "classic",
    name: "经典三级片",
    icon: "ri-film-line",
    desc: "八九十年代最具代表性的作品，用胶片记录一座城市的欲望与克制。",
  },
  {
    key: "latest",
    name: "最新上映",
    icon: "ri-time-line",
    desc: "近五年新作，题材更当代，镜头语言也更锋利。",
  },
  {
    key: "auteur",
    name: "导演专题",
    icon: "ri-clapperboard-line",
    desc: "按创作者线索梳理作品，看同一位导演如何反复书写同一个命题。",
  },
  {
    key: "romance",
    name: "爱情伦理",
    icon: "ri-heart-3-line",
    desc: "关于靠近与退缩，关于关系里那些说不出口的部分。",
  },
  {
    key: "suspense",
    name: "悬疑惊悚",
    icon: "ri-moon-foggy-line",
    desc: "灯光、走廊与一扇没关好的门，气氛比答案更重要。",
  },
  {
    key: "retro",
    name: "复古港风",
    icon: "ri-video-line",
    desc: "霓虹、雨水与旧电车，一个时代的视觉记忆。",
  },
];

export const directors = ["陈墨白", "苏念真", "何雨川", "关静山", "罗维安"];

export const yearOptions = [2025, 2024, 2023, 2022, 2021, 2020, 1999, 1998, 1997, 1996, 1995, 1994, 1993, 1992, 1991];